// extracted by mini-css-extract-plugin
export default {"avatar":"Awml3x","withBorder":"GodvU2","memberInitials":"H3TGaA","avatarPlaceholder":"ZSUPFt","loggedOut":"p6L7cw"};